import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Tendies from "./pages/Tendies";
import Story from "./pages/Story";
import FAQs from "./pages/FAQs";
import HallsOfAmenti from "./pages/HallsOfAmenti";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" exact element={<Home />}></Route>
        <Route path="/tendies" exact element={<Tendies />}></Route>
        <Route path="/story" exact element={<Story />}></Route>
        <Route path="/faqs" exact element={<FAQs />}></Route>
        <Route
          path="/halls-of-amenti"
          exact
          element={<HallsOfAmenti />}
        ></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
